// @ts-nocheck
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export const ConsentRenderer = ({ content }) => {
  const schema = {
    ...defaultSchema,
    attributes: {
      ...defaultSchema?.attributes,
      span: ["className"],
    },
  };

  return (
    <Box>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeRaw], [rehypeSanitize, schema]]}
        components={{
          h1: ({ node, ...props }) => (
            <Typography
              variant="h2"
              sx={{
                mb: 3,
                pb: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                color: "#fff",
                fontWeight: 700,
              }}
              {...props}
            />
          ),

          h2: ({ node, ...props }) => (
            <Typography
              variant="h4"
              sx={{
                mt: 4,
                mb: 2,
                color: "#fff",
                fontWeight: 600,
                fontSize: "20px",
              }}
              {...props}
            />
          ),

          h3: ({ node, ...props }) => (
            <Typography
              variant="h5"
              sx={{
                mt: 3,
                mb: 1.5,
                color: "#fff",
                fontWeight: 600,
                fontSize: "18px",
              }}
              {...props}
            />
          ),

          p: ({ node, ...props }) => (
            <Typography
              variant="body1"
              sx={{
                mb: 2,
                color: "#fff",
                textAlign: "justify",
                lineHeight: 1.75,
              }}
              {...props}
            />
          ),

          ul: ({ node, ...props }) => (
            <Box
              component="ul"
              sx={{
                mb: 3,
                pl: 4,
                color: "#fff",
                "& li": { mb: 1 },
              }}
              {...props}
            />
          ),

          ol: ({ node, ...props }) => (
            <Box
              component="ol"
              sx={{
                mb: 3,
                pl: 4,
                color: "#fff",
                "& li": { mb: 1 },
              }}
              {...props}
            />
          ),

          li: ({ node, ...props }) => (
            <Box component="li" sx={{ pl: 0.5 }} {...props} />
          ),

          strong: ({ node, ...props }) => (
            <Box
              component="strong"
              sx={{ fontWeight: 600, color: "#fff" }}
              {...props}
            />
          ),

          em: ({ node, ...props }) => (
            <Box
              component="em"
              sx={{ fontStyle: "italic", color: "rgba(255,255,255,0.85)" }}
              {...props}
            />
          ),

          blockquote: ({ node, ...props }) => (
            <Box
              component="blockquote"
              sx={{
                borderLeft: "4px solid",
                borderColor: "divider",
                pl: 2,
                my: 2,
                fontStyle: "italic",
                color: "rgba(255,255,255,0.85)",
              }}
              {...props}
            />
          ),
          a: ({ node, href, ...props }) => {
            const isEmail = href?.startsWith("mailto:");
            return (
              <Box
                component="a"
                href={href}
                className={isEmail ? "consent-email" : undefined}
                sx={{
                  color: "#fff",
                  ...(isEmail && {
                    color: "var(--primary-pink-hex)",
                  }),
                }}
                {...props}
              />
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

ConsentRenderer.propTypes = {
  content: PropTypes.string.isRequired,
};